import { render, staticRenderFns } from "./StatsEtablissementParType.vue?vue&type=template&id=08b2079a&"
import script from "./StatsEtablissementParType.vue?vue&type=script&lang=js&"
export * from "./StatsEtablissementParType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports